(ns frontend.ui.component.alert.style
  (:require
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]
   [garden.util :refer [space-join]]))

(defn icon
  [variant]
  {:color     (theme/color [:alert :variant variant])
   :font-size "20px"
   :padding   "16px 0 16px 20px"})

(defn child
  []
  {:padding "12px 12px"})

(defn alert
  [variant]
  (with-meta
    {:border        (space-join ["1px" "solid" (theme/color [:alert :border])])
     :display       "flex"
     :align-items   "center"
     :border-radius "4px"
     :position      "relative"}
    {:pseudo
     {:before
      {:content    "''"
       :display    "inline-block"
       :width      "3px"
       :position   "absolute"
       :top        "6px"
       :bottom     "6px"
       :left       "6px"
       :background (theme/color [:alert :variant variant])}}}))
